import { useEffect, useMemo, useRef } from "react"

import { useSelector } from "react-redux"

import "chartjs-adapter-moment"

import {
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip
} from "chart.js"
import { Line } from "react-chartjs-2"

import EmptyChart from "../../../Components/Charts/EmptyChart"
import { debounce } from "../../../Utils/utils"
import { alertsChartOptions } from "../../DashboardPage/components/chartsOptions"
import { getGradient, tooltipLine } from "../../DashboardPage/components/chartsPlagins"

ChartJS.register(TimeScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

ChartJS.defaults.color = "#667085"
// ChartJS.defaults.font.family = 'FontAwesome, Inter, sans-serif';

ChartJS.defaults.font.family = "Inter, sans-serif"
ChartJS.defaults.plugins.tooltip.titleAlign = "center"
ChartJS.defaults.plugins.tooltip.padding = 12
ChartJS.defaults.plugins.tooltip.titleMarginBottom = 8
ChartJS.defaults.plugins.tooltip.titleFont = {
  fontFamily: "Inter, sans-serif",
  lineHeight: 1.2,
  size: 14,
  style: "normal",
  weight: "700"
}

const Chart = ({ loading, data, height, type }) => {
  const theme = useSelector((state) => state.nav.theme)

  //for better resize chart if resize window
  const chartRef = useRef(null)

  const handleResize = debounce(() => {
    if (chartRef.current) {
      chartRef.current.resize()
    }
  }, 500)

  //for udate chart after changing browser tab if chart is unvisible
  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible" && chartRef.current) {
      chartRef.current.update()
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    document.addEventListener("visibilitychange", handleVisibilityChange)
    return () => {
      window.removeEventListener("resize", handleResize)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  const chartOptions = useMemo(() => alertsChartOptions(theme), [theme])

  const getChartData = (data) => ({
    labels: [...data?.labels],
    datasets: [
      {
        label: "All projects",

        data: data?.result?.data,
        //data: [...data?.result]?.map(el => el?.data),

        selectType: "count", //'volume',

        total: data?.result?.data,
        ethoca: data?.result?.ethoca,
        rdr: data?.result?.rdr,
        cdrn: data?.result?.cdrn,

        //total: [...data?.result]?.map(el => el?.data),
        //ethoca: [...data?.result]?.map(el => el?.ethoca),
        //rdr: [...data?.result]?.map(el => el?.rdr),
        //cdrn: [...data?.result]?.map(el => el?.cdrn),

        borderColor: "#225AEA",
        borderWidth: 2,
        pointHoverRadius: 8,
        pointHoverBorderWidth: 2,
        pointHoverBackgroundColor: "white",
        yAxisID: "y",
        fill: true,
        backgroundColor: function (context) {
          const chart = context.chart
          const { ctx, chartArea } = chart
          if (!chartArea) return
          return getGradient(ctx, chartArea)
        }
      }
    ]
  })

  if (!data) {
    return (
      <div
        className="empty-screen"
        style={{ height: height || "235px", width: "100%", position: "relative" }}
      >
        <EmptyChart type={type} theme={theme} loading={loading} />
      </div>
    )
  }

  const chartData = getChartData(data)

  return (
    <Line
      ref={chartRef}
      options={chartOptions}
      data={chartData}
      height={height || 235}
      plugins={[tooltipLine]}
    />
  )
}

export default Chart
